import * as React from 'react';
export const tronSvg = React.forwardRef(function tronSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#EF0027',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.932 9.913 7.5 7.257l7.595 19.112 10.583-12.894-3.746-3.562Zm-.232 1.17 2.208 2.099-6.039 1.093 3.831-3.192Zm-5.142 2.973-6.364-5.278 10.402 1.913-4.038 3.365Zm-.453.935-1.038 8.58L9.472 9.487l6.633 5.504Zm.96.454 6.687-1.21-7.67 9.343.983-8.133Z',
      fill: '#fff',
    }),
  );
});
tronSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var tron = {
  category: 'brand',
  colorable: false,
  name: 'tron',
  svg: tronSvg,
};
